import { render, staticRenderFns } from "./ActivitiesCarouselComponent.vue?vue&type=template&id=f1751c6e&scoped=true"
import script from "./ActivitiesCarouselComponent.vue?vue&type=script&lang=js"
export * from "./ActivitiesCarouselComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1751c6e",
  null
  
)

export default component.exports